import type { LeadDetail } from "@school-sales-ai/shared";

/**
 * The links, tolerating a backend one deploy behind: Vercel and Render deploy
 * independently, and a lead page that crashed on a missing array would cost the
 * team the whole detail for those minutes.
 */
export function linkedLeadsOf(lead: LeadDetail): LeadDetail["linkedLeads"] {
  return lead.linkedLeads ?? [];
}
